import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
export var ErrorModal = function() {
    var history = useHistory();
    var handleClose = function() {
        return history.replace(getCurrentPath().delete("failed").toString());
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        onClose: handleClose,
        height: "auto",
        padding: getSpacing("8x", "5x"),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "pIJqK/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Unable to connect to your POS"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ic5XkO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "If you have many products in your POS system, setup of the POS integration may take a few minutes to finish. Refresh the page and try again in 5-10 minutes. If the issue persists, please "
                        },
                        {
                            type: 8,
                            value: "ContactFormLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "contact us"
                                }
                            ]
                        }
                    ],
                    values: {
                        ContactFormLinkFormatting: ContactFormLinkFormatting
                    }
                })
            })
        ]
    });
};
